module.exports = __webpack_public_path__ + "img/checkmark.c4cfddbc.svg";